import { howItWorks } from '@/mocks/home';

export default function HowItWorksSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            三步创建，一键上线
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            无需任何技术背景，像写文档一样简单
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {howItWorks.map((item, index) => (
            <div key={item.step} className="relative group">
              <div className="text-center">
                <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center mx-auto mb-5">
                  <span className="text-xl font-bold text-background-50">{item.step}</span>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
              {index < howItWorks.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(50%+40px)] w-[calc(100%-80px)]">
                  <div className="border-t-2 border-dashed border-primary-200"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}